export default __webpack_public_path__ + "static/media/No.6-7.24603953.jpg";